//libs
import { styled } from '@nykaa/ui-components';

//components
import ButtonBase from '@nykaa/ui-components/Button';

//constants
import { MAX_DWEB_WIDTH } from 'shared/styles/base';
import { GUTTER_SPACE, BANNER_WIDTH } from './constants';

export const BannerContainer = styled.div`
  position: relative;

  .plp-new-banner {
    margin-left: auto;
    overflow: visible;
    margin-bottom: ${({ theme }) => theme.spacing.spacing120};
  }

  @media (min-width: 1441px) {
    .plp-new-banner {
      overflow: hidden;
    }
  }
`;

export const ArrowRight = styled(ButtonBase)`
  height: 48px;
  width: 48px;
  position: absolute;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  right: 28px;
  ${({ theme }) => ` 
    border-radius: ${theme.borders.radiusFull};
    border-color: ${theme.colors.textDecorative};
    box-shadow: ${theme.elevations.shadow200};
  `}

  i {
    right: -2px;
    margin-right: 0;
    box-shadow: none;
  }
`;

export const ArrowLeft = styled(ArrowRight)`
  transform: rotate(90deg);
  right: 0;
  left: 28px;

  i {
    left: 0;
    top: 1px;
    box-shadow: none;
  }
`;

export const SlideIndex = styled.div`
  ${({ theme }) => theme.typography.subTitleMedium};
  color: ${({ theme }) => theme.colors.textSecondary};
  position: absolute;
  top: -24px;
  right: 2px;
`;

export const BannerImage = styled.div`
  border-radius: ${({ theme }) => theme.borders.radius30};
  img {
    border-radius: ${({ theme }) => theme.borders.radius30};
  }
  @media (max-width: ${MAX_DWEB_WIDTH}px) {
    width: calc(100vw - ${GUTTER_SPACE}px);
  }
  @media (min-width: 1441px) {
    /* width is calculated as (device with - gutter space), where gutter space is 96 */
    width: ${BANNER_WIDTH}px;
  }
`;
